<template>
  <vetster-search-facet-group
    :label="$t('search.species-treated')"
    group="SPECIES"
    :expanded="expanded"
  >
    <div class="relative">
      <div
        v-if="disabled"
        class="
          absolute
          inset-0
          bg-white
          opacity-75
          text-indigo-600
          font-medium
          text-base
          flex
          items-center
          justify-center
        "
      />
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-1">
        <div
          v-for="option in getSpeciesTreated"
          :key="`${option.name}`"
          class="flex items-start"
        >
          <div class="flex items-center h-5">
            <label
              :for="option.name"
              :class="
                disabled
                  ? 'cursor-not-allowed text-neutral-400'
                  : 'cursor-pointer text-neutral-700'
              "
            >
              <input
                :id="option.name"
                v-model="input"
                :disabled="disabled"
                type="checkbox"
                class="
                  cursor-pointer
                  focus:ring-indigo-500
                  h-4
                  w-4
                  text-indigo-600
                  border-neutral-300
                  rounded
                "
                :value="option.name"
              />
              <span class="text-sm ml-1.5">{{ $t(`pets.species.${option.name}`) }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </vetster-search-facet-group>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';

export default {
  name: 'VetsterSpeciesTreatedInput',

  components: { VetsterSearchFacetGroup },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    expanded: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      input: [],
    };
  },

  computed: {
    ...mapGetters('speciesTreated', ['getSpeciesTreated']),
    speciesTreated() {
      return this.$store.state.search.inputs.species_treated || [];
    },
  },

  watch: {
    input: {
      handler(data) {
        this.$store.commit('search/setInputs', {
          species_treated: data,
        });
      },
      deep: true,
    },
    speciesTreated: {
      handler(data) {
        this.input = data;
      },
      deep: true,
    },
  },

  async created() {
    await this.$store.dispatch('speciesTreated/fetchSpeciesTreated');
    this.input = this.speciesTreated;
  },
};
</script>
